module.exports = __webpack_public_path__ + "static/img/16052C_1_2_3_R_20200605_LC.b9e5bc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16052C_1_2_3_R_20200605_LC.png
// module id = +3JF
// module chunks = 0